export default "__VITE_ASSET__fiShR2ea__"